export default {
    rubbers: [],
    rubbersRaw: [],
    statuses: [],
    statusColors: [
        { statusId: 10, color: 'success' },
        { statusId: 20, color: 'primary' },
        { statusId: 30, color: 'error' },
    ],
    rubbersLoading: false,
    rubbersReportLoading: false,
    additionalJobSearchResults: [],
    additionalJobSearchLoading: false,
    additionalJobSaveLoading: false,
    comments: [],
    commentsLoading: false,
    commentSaveLoading: false,
    commentDeleteLoading: false,
}